export default __webpack_public_path__ + "static/ai-marketing-4-6fa37b0010eec18dc2919e2d2d0d0a14.webp";